// BL-407: the Home Screen / install name follows the sign-in door the person arrived at.
// Names come from the door's identity in src/config/signInBranding.json; nothing is spelled out here.
// Browser-tab icons follow the door, on every page. Replaces whatever icon links the page already has.
export function applyDoorFavicons(door, doc = document, publicUrl = process.env.PUBLIC_URL || '') {
    doc.querySelectorAll('link[rel~="icon"]').forEach((link) => link.remove());
    const add = (href, attributes) => {
        const link = doc.createElement('link');
        link.rel = 'icon';
        Object.entries(attributes).forEach(([name, value]) => link.setAttribute(name, value));
        link.setAttribute('href', `${publicUrl}/${href}`);
        doc.head.appendChild(link);
    };
    add(door.favicons.ico, { sizes: '16x16 32x32 48x48' });
    add(door.favicons.png, { type: 'image/png', sizes: '32x32' });
    if (door.favicons.svg) add(door.favicons.svg, { type: 'image/svg+xml' });
}

export function applyDoorIdentity(door, doc = document, publicUrl = process.env.PUBLIC_URL || '', hostname = '') {
    applyDoorFavicons(door, doc, publicUrl);
    const manifest = doc.querySelector('link[rel="manifest"]');
    const host = String(hostname).toLowerCase().split(':')[0];
    const onOwnAddress = host !== '' && door.hostnames.some((name) => name.toLowerCase() === host);
    if (manifest) manifest.href = `${publicUrl}/${onOwnAddress ? door.hostManifest : door.manifest}`;
    // Each door shows its own Home Screen icon (the real logo for The Ride, the glass-panel mark for IntelAgent).
    let touchIcon = doc.querySelector('link[rel="apple-touch-icon"]');
    if (!touchIcon) {
        touchIcon = doc.createElement('link');
        touchIcon.rel = 'apple-touch-icon';
        doc.head.appendChild(touchIcon);
    }
    touchIcon.href = `${publicUrl}/${door.icon}`;
    let title = doc.querySelector('meta[name="apple-mobile-web-app-title"]');
    if (!title) {
        title = doc.createElement('meta');
        title.name = 'apple-mobile-web-app-title';
        doc.head.appendChild(title);
    }
    title.content = door.installedName || door.identity.homeScreenName;
}
